// We require these here, rather than in the files
// that references them directly because these files are client only
// and can't be included in code that also runs on the server

require('./vendor/owl.carousel.js');
require('@a0/docs-components/metrics');
require('./browser/slate');
require('./browser/frameListener');
// Removed 2021.10.05 - can be restored if trustarc injected unscoped css again
// require('./browser/trustArcMutationObserver');
